import React, {useEffect, useState} from 'react';
import api from '../../common/api';
import makeStyles from "@material-ui/styles/makeStyles";
import {ConfirmDialog, MaterialTable, PageHeader} from '../../components';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Mobile from './components/mobile'
import DailyFeedRate from "./components/dailyFeedRate";
import Icon from '@material-ui/core/Icon';
import moment from 'moment';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {useGlobalState} from '../../state';


const useStyles = makeStyles(theme => ({
    root: props => ({
        // margin: props.isDesktop ? theme.spacing(4) : theme.spacing(1)
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
    link: {
        display: 'flex',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    red:{
        color:'red'
    },
    green:{
        color: 'green'
    },
    gridMargin:{
        margin:theme.spacing(1.5)
    },
    formControl: {
        /* marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        minWidth: 160, */
    },
    searchButton:{
        color:'white',
        width:theme.spacing(21.25),
        backgroundColor:'#EF5350',
        '&:hover':{
            backgroundColor:'#E53935',
        },
        margin:theme.spacing(1),
        padding:theme.spacing(1),
        marginLeft: theme.spacing(1.6),
        marginBottom:theme.spacing(4)
    },
    success: {
        color:'white',
        backgroundColor:'#4CAF50',
        '&:hover':{
            backgroundColor:'#388E3C',
        },
        width:theme.spacing(13.75),
        margin:theme.spacing(1),
        padding:theme.spacing(1),
        marginLeft: theme.spacing(1.6),
        marginBottom:theme.spacing(4)
    }
}));

//let currentDailyFeedRate = undefined;
// let editMode = false;
const DailyFeedRatesView = ({showError, showMessage, history}) => {
    const [{user}] = useGlobalState();
    const [dailyFeedRates, setDailyFeedRates] = useState([]);
    const [feedMaterials, setFeedMaterials] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentDailyFeedRate, setCurrentDailyFeedRate] = useState(undefined)
    const [showDailyFeedRateDialog, setShowDailyFeedRateDialog] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [filterSelectedStartDate, setFilterSelectedStartDate] = useState(null);
    const [filterSelectedEndDate, setFilterSelectedEndDate] = useState(null);
    const [errorMessage, setErrorMessage] = useState('')
    const theme = useTheme();

    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({isDesktop});

    function onNewDailyFeedRate(event) {
        setEditMode(false)
        setShowDailyFeedRateDialog(true);
    }

    function handleDailyFeedRateClose() {
        setErrorMessage(null);
        setCurrentDailyFeedRate(undefined)
        setShowDailyFeedRateDialog(false);
    }

    function handleDeleteConfirmClose() {
        setErrorMessage(null);
        setShowDeleteConfirm(false);
    }

    const removeErrorMessage = value =>{
        setErrorMessage('');
    }


    const onFarmDeleteConfirm = () => {
        if (currentDailyFeedRate && currentDailyFeedRate.id) {
            setShowDeleteConfirm(false);
            //setLoading(true);
            // showError('');
            const response = api.delete(`daily-feed-rates/${currentDailyFeedRate.id}`);

            response.then(res => {
                if (res) {
                    let index = dailyFeedRates.findIndex((srcDailyFeedRate) => {
                        return srcDailyFeedRate.id === currentDailyFeedRate.id;
                    });
                    let newDailyFeedRates = [...dailyFeedRates];
                    newDailyFeedRates.splice(index, 1);
                    setDailyFeedRates(newDailyFeedRates);
                }
            }).catch(err => {
                if (err.message) {
                    if (err.message === 'Bad Request' || err.message === 'No data found')
                        showError('DailyFeedRate not Deleted');
                    else
                        showError(err.message)
                } else {
                    showError('Unknown Error')
                }
            }).finally(() => {
                setLoading(false);
                setCurrentDailyFeedRate(undefined)
            });

        }
    };

    const onDelete = (dailyFeedRate) => {
        setCurrentDailyFeedRate(dailyFeedRate)
        setShowDeleteConfirm(true);
    };

    const onDailyFeedRateSave = (dailyFeedRate, setPopupLoading) => {
        //setLoading(true);
        // setShowDailyFeedRateDialog(false);
        // showError('');
        // showMessage('');
        const response = api.post('daily-feed-rates', {
            ...dailyFeedRate,
        });

        response.then(res => {
            setDailyFeedRates([...dailyFeedRates, {
                ...res,
                ...dailyFeedRate
            }]);
            setShowDailyFeedRateDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('DailyFeedRate not added');
                else
                setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
            setPopupLoading(false);
        });
    };


    const onDailyFeedRateEdit = (dailyFeedRate) => {
        setCurrentDailyFeedRate(dailyFeedRate)
        setEditMode(true)
        setShowDailyFeedRateDialog(true);
    };

    const onDailyFeedRateUpdate = (dailyFeedRate, setPopupLoading) => {
        // setShowDailyFeedRateDialog(false);
        //setLoading(true);
        // showError('');
        const response = api.post(`daily-feed-rates/${dailyFeedRate.id}`, {
            ...dailyFeedRate,           
        });
        response.then(() => {
            let index = dailyFeedRates.findIndex((srcDailyFeedRate) => {
                return srcDailyFeedRate.id === dailyFeedRate.id;
            });
            setDailyFeedRates([...dailyFeedRates.slice(0, index),
                {...dailyFeedRate},
                ...dailyFeedRates.slice(index + 1)]);
            setShowDailyFeedRateDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                setErrorMessage('DailyFeedRate not Updated');
                else
                setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
            setPopupLoading(false);
        });
    };

//Get all Daily Entry By Date API Call
const getAllDailyFeedRateByDate = () => {

    if(filterSelectedEndDate === null && filterSelectedStartDate === null){
        getAllDailyFeedRates()
    }
    if(filterSelectedEndDate !== null && filterSelectedStartDate !== null && 
        filterSelectedEndDate < filterSelectedStartDate){
        showError('Start Date is Greater than or Equal to End Date');
        return
    }
    let payload = {
        startDate:filterSelectedStartDate,
        endDate:filterSelectedEndDate,
        
    }

    setLoading(true);
    showError('');
    showMessage('');

    const response = api.post('daily-feed-rates-by-date',{...payload});

    response.then(res => {
        let newResponse = []
        res.forEach((resElement)=>{
            if (resElement.feedRates !== null && resElement.feedRates !== undefined){
                (resElement.feedRates).forEach((feedRate)=>{
                    resElement = {
                        ...resElement,
                        [feedRate.materialName]:feedRate.feedRate
                    }
                })
            }
            newResponse = [
                ...newResponse,
                resElement
            ]
        })
        setDailyFeedRates([...newResponse]);
    }).catch(err => {
        if (err.message) {
            if (err.message === 'Bad Request' || err.message === 'No data found')
                showError('No Daily Feed Rates Found');
            else
                showError(err.message)
        } else {
            showError('Unknown Error')
        }
    }).finally(() => {
        setLoading(false);
    });
}

    //Get all DailyFeedRates API Call
    const getAllDailyFeedRates = () => {
        setShowDailyFeedRateDialog(false);
        setLoading(true);
        showError('');
        showMessage('');
        const response = api.get('daily-feed-rates');
        response.then(res => {
            let newResponse = []
            res.forEach((resElement)=>{
                if (resElement.feedRates !== null && resElement.feedRates !== undefined){
                    (resElement.feedRates).forEach((feedRate, index)=>{
                        resElement = {
                            ...resElement,
                            [feedRate.materialName]:feedRate.feedRate
                        }
                    })
                }
                newResponse = [
                    ...newResponse,
                    resElement
                ]
            })
            setDailyFeedRates([...newResponse]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No DailyFeedRates Found');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    }
    
    const getFeedMaterials = () => {
        const resp=api.get('feed-rate-materials');
        resp.then(res=>{
            setFeedMaterials(res)
        }).catch(err => {
            // 404 when no feed material exists yet in Material Master
            setFeedMaterials([])
            if (err.message === 'No data found')
                showError('No feed material found. Add a Feed type under Material Master first.');
            else
                showError(err.message || 'Unknown Error')
        })
    }
    const handleFilterStartDateChange = date => {
        setFilterSelectedStartDate(date);
    };

    const handleFilterEndDateChange = date => {
        setFilterSelectedEndDate(date);
    };
    const clearDateRangeFilter=()=>{
        setFilterSelectedStartDate(null)
        setFilterSelectedEndDate(null)
        getAllDailyFeedRates()

    }
    const onLoad =() =>{
        getAllDailyFeedRates()
        getFeedMaterials()
    }

    useEffect(onLoad, []);

    let dailyFeedRateNameColumn = {
        render: rowData => <Mobile data={rowData}
                                   onEdit={() => {
                                       onDailyFeedRateEdit(rowData)
                                   }}
                                   onDelete={() => {
                                       onDelete(rowData)
                                   }}
        />,
        // Other columns are hidden on mobile, and material-table skips hidden columns when searching
        customFilterAndSearch: (term, rowData) => {
            const values = [
                moment(rowData.date).format("DD-MM-YYYY"),
                ...(rowData.feedRates || []).flatMap(feed => [feed?.materialName, feed?.feedRate]),
            ];
            return values.some(value => value !== undefined && value !== null &&
                String(value).toLowerCase().includes(term.toLowerCase()));
        },
    };
    let actions = [];
    if (isDesktop) {
        dailyFeedRateNameColumn={title: 'Large', field: 'large', hidden: true, editable: 'never'}
        actions = [
            rowData => ({
                icon: () => <Icon color='primary'>edit</Icon>,
                tooltip: 'Edit Daily Feed Rates',
                onClick: (event, rowData) => onDailyFeedRateEdit(rowData),
                hidden: (user.role === "STAFF" && !moment(rowData.createTime).isSame(moment(), "date") ? true : false)
            }),
            rowData => ({
                icon: () => <Icon color='error'>delete</Icon>,
                tooltip: 'Delete Daily Feed Rates',
                onClick: (event, rowData) => onDelete(rowData),
                hidden: (user.role === "STAFF" && !moment(rowData.createTime).isSame(moment(), "date") ? true : false)
            })
        ]
    }

    let columns= [ 
        {title: 'id', field: 'id', hidden: true},
        dailyFeedRateNameColumn,
        {title: 'Date', field: 'date', type: 'datetime', hidden: !isDesktop, defaultSort: 'desc',
        cellStyle: {textAlign:'center'}, headerStyle: {textAlign:'center'},
        editable: 'never',
        render: rowData => {
            return <span>{moment(rowData.date).format("DD-MM-YYYY")}</span>
        }},
        // one column per feed material set up in Material Master, so rates are visible without opening the row
        ...feedMaterials.map(feed => ({title: feed.materialName, field: feed.materialName, hidden: !isDesktop, editable: 'never'}))
    ]

    /* if( allColumns !== [] && isDesktop){
        columns = [
            ...columns,
            ...allColumns
        ]
    } */
    


    return <div className={classes.root}>
        <PageHeader
            title="Daily Feed Rate Details"
            actions={[
                { label: 'Add Daily Feed Rate', icon: <AddCircleIcon />, onClick: onNewDailyFeedRate, variant: 'contained', color: 'primary' },
            ]}
            filters={
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        margin="none"
                        autoOk
                        variant="inline"
                        inputVariant='outlined'
                        label="From"
                        format="dd/MM/yyyy"
                        size="small"
                        value={filterSelectedStartDate || null}
                        onChange={handleFilterStartDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    <KeyboardDatePicker
                        margin="none"
                        autoOk
                        variant="inline"
                        inputVariant='outlined'
                        label="To"
                        format="dd/MM/yyyy"
                        size="small"
                        value={filterSelectedEndDate || null}
                        onChange={handleFilterEndDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
            }
            onSearch={getAllDailyFeedRateByDate}
            onClearSearch={clearDateRangeFilter}
        />
        <MaterialTable
            // Desktop only: on mobile the card already shows every feed rate, and the expand arrow just takes space
            detailPanel={isDesktop ? rowData => (
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                {rowData.feedRates.map(feed => {
                                    return <TableCell>{feed.materialName}</TableCell>
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                {rowData.feedRates.map(feed => {
                                    return <TableCell style={{textAlign:"center"}}>{feed.feedRate}</TableCell>
                                })}
                            </TableRow>
                        </TableBody>
                    </Table>
            ) : undefined}
            isLoading={loading}
            columns={columns}
            data={dailyFeedRates}
            title='Daily Feed Rate Details'
            options={{
                actionsColumnIndex: -1,
                search: true,
                showTitle: true,
                toolbar: true,
                header: isDesktop,
            }}
            actions={actions}
        />
        <DailyFeedRate deleteErrorMessage={removeErrorMessage} errorMessage={errorMessage} showDialog={showDailyFeedRateDialog} handleClose={handleDailyFeedRateClose} onSave={onDailyFeedRateSave} 
        onEdit={onDailyFeedRateUpdate}  editMode={editMode} data={currentDailyFeedRate} feedMaterials={feedMaterials}/>
        <ConfirmDialog showDialog={showDeleteConfirm}
                       handleClose={handleDeleteConfirmClose}
                       onConfirm={onFarmDeleteConfirm}
                       title='Delete Details ?'
                       subText='This action will delete the Daily Feed Rate Details. Please confirm.'/>
    </div>
}

export default DailyFeedRatesView;
